export interface ITypeOffer {
  id?: number;
  name?: string;
  slug?: string;
  description?: string;
  param0?: string;
  param1?: string;
  param2?: string;
  param3?: string;
  type?: string;
}

export class TypeOffer implements ITypeOffer {
  constructor(
    public id?: number,
    public name?: string,
    public slug?: string,
    public description?: string,
    public param0?: string,
    public param1?: string,
    public param2?: string,
    public param3?: string,
    public type?: string,
  ) {
    this.id = id;
    this.name = name;
    this.slug = slug;
    this.description = description;
    this.param0 = param0;
    this.param1 = param1;
    this.param2 = param2;
    this.param3 = param3;
    this.type = type;
  }
}
